import { useRoute } from "vue-router";
import { onMounted, ref, watch, reactive } from "vue";
import { weChatrequest } from '@/utils/request';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  name: "DeviceInfo",
  props: ["deviceDetail"],
  emits: ['refresh'],
  setup(props, {
    emit
  }) {
    const route = useRoute();
    let deviceInfo = ref({});

    // 编辑模式
    const editMode = reactive({
      cylinderSnType: false,
      batCouValue: false,
      switchTimeout: false
    });

    // 编辑值（用于存储原始值，取消时恢复）
    const originalValues = reactive({
      cylinderSnType: '0',
      batCouValue: null,
      switchTimeout: null
    });

    // 编辑值（当前编辑的值）
    const editValues = reactive({
      cylinderSnType: '0',
      batCouValue: null,
      switchTimeout: null
    });

    // 指令下发相关
    const writeLoading = reactive({
      cylinderSnType: false,
      batCouValue: false,
      switchTimeout: false
    });
    const writeTime = reactive({
      cylinderSnType: '',
      batCouValue: '',
      switchTimeout: ''
    });
    onMounted(() => {});
    watch(() => props.deviceDetail, val => {
      deviceInfo.value = props.deviceDetail;
      // 同步编辑值
      if (val) {
        const cylinderSnType = val.cylinderSnType !== null && val.cylinderSnType !== undefined ? String(val.cylinderSnType) : '0';
        originalValues.cylinderSnType = cylinderSnType;
        editValues.cylinderSnType = cylinderSnType;
        originalValues.batCouValue = val.batCouValue;
        editValues.batCouValue = val.batCouValue;
        originalValues.switchTimeout = val.switchTimeout;
        editValues.switchTimeout = val.switchTimeout;
      }
    }, {
      deep: true
    });

    // 切换编辑模式
    const toggleEdit = fieldName => {
      editMode[fieldName] = true;
      // 保存当前值作为原始值
      originalValues[fieldName] = editValues[fieldName];
    };

    // 取消编辑
    const cancelEdit = fieldName => {
      editMode[fieldName] = false;
      // 恢复原始值
      editValues[fieldName] = originalValues[fieldName];
    };
    let formatCommunicationState = communicationState => {
      if (communicationState == 0) {
        return '报警';
      } else if (communicationState == 1) {
        return '掉线';
      } else if (communicationState == 2) {
        return '休眠';
      } else if (communicationState == 3) {
        return '在线';
      }
    };

    // 获取气瓶传感器类型标签
    const getCylinderSnTypeLabel = value => {
      if (value === '0' || value === 0) {
        return '压力传感器';
      } else if (value === '1' || value === 1) {
        return '宝鸡麦克';
      }
      return '-';
    };

    // 指令下发处理
    const handleWrite = async fieldName => {
      const fieldLabels = {
        cylinderSnType: '气瓶传感器类型',
        batCouValue: '电池容量',
        switchTimeout: '开关阀超时时间'
      };

      // 获取编辑后的值
      let currentValue = editValues[fieldName];

      // 验证值是否有效
      if (currentValue === null || currentValue === undefined || currentValue === '') {
        ElMessage.warning(`请先设置${fieldLabels[fieldName]}`);
        return;
      }

      // 开关阀超时时间验证范围
      if (fieldName === 'switchTimeout') {
        const timeout = Number(currentValue);
        if (timeout < 10 || timeout > 60) {
          ElMessage.warning('开关阀超时时间必须在10-60秒之间');
          return;
        }
      }

      // 电池容量验证
      if (fieldName === 'batCouValue') {
        const batValue = Number(currentValue);
        if (batValue < 0) {
          ElMessage.warning('电池容量必须大于等于0');
          return;
        }
      }
      try {
        await ElMessageBox.confirm(`确定要下发${fieldLabels[fieldName]}指令吗？`, '确认下发', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        writeLoading[fieldName] = true;
        let writeValue;
        if (fieldName === 'cylinderSnType') {
          writeValue = Number(currentValue);
        } else {
          writeValue = Number(currentValue);
        }
        const params = {
          id: deviceInfo.value.id,
          writeName: fieldName,
          [fieldName]: writeValue
        };
        const res = await weChatrequest({
          url: '/api/v1/actuator/write',
          method: 'POST',
          data: params
        });
        if (res.code == 0) {
          ElMessage.success('指令下发成功');
          editMode[fieldName] = false;
          // 通知父组件刷新
          emit('refresh');
        } else {
          ElMessage.closeAll();
          ElMessage.error(res.msg || '指令下发失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('指令下发失败，请重试');
        }
      } finally {
        writeLoading[fieldName] = false;
      }
    };
    return {
      deviceInfo,
      formatCommunicationState,
      getCylinderSnTypeLabel,
      handleWrite,
      writeLoading,
      writeTime,
      editValues,
      editMode,
      toggleEdit,
      cancelEdit
    };
  }
};